import { takeEvery, put, take, fork, call } from "redux-saga/effects";
import * as Store from './registerCompanyStore';
import { push } from "react-router-redux";
import { actions } from 'react-redux-form'
import * as api from '../../api/companyApi';
import { actions as rrfActions } from 'react-redux-form';
import * as Notifications from '../../notifications/notificationsStore'

export function* watchRegisterCompanySagas() {
    yield takeEvery(Store.ActionType.RegisterRequest, startRegisterCompany)

    yield fork(registerCompanyFlow);
}

function* startRegisterCompany() {
    yield put(push("/register/company"));
}
function* registrationFailed(){
    yield put(Notifications.actionCreators.addNotification({id: "registrationFailed", message: "Yrityksen rekisteröinti epäonnistui.", variant: "error", autohide: true }));
  }
function* registerCompanyFlow() {
    while (true) {
        const response = yield take(Store.ActionType.Submit);

        const companyData = response.data;

        const result = yield call(api.registerCompany, companyData);

        if (result) {
            yield put(Store.actionCreators.registerSuccess());
            yield put(rrfActions.reset("registrationPrompt"))
            // Wait for confirmation to continue.
            yield take(Store.ActionType.SuccessContinue);
            // Go back to front page.
            yield put(push("/"));
            // Reset filled register form.
            yield put(actions.reset("registerCompanyModel"));
        } else {
            yield put(Store.actionCreators.registerError("Invalid data"));
            yield fork(registrationFailed);
            
        }

    }
}



// WEBPACK FOOTER //
// ./src/register/company/registerCompanySagas.ts